import styled, { css } from 'styled-components';

import { elevation } from 'ggApp/utils/mixins';
import omitProps from 'ggApp/utils/omitProps';
import EmptyCart from 'ggApp/shared/components/CartSummary/Overlay/EmptyCart';

export const ANIMATION_DURATION_IN_MS = 350;

export const Wrap = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const Wrapper = styled.div`
    overflow-y: auto;

    ::-webkit-scrollbar {
        width: 0px;
        background: transparent;
    }
`;

export const MixContainer = styled.div`
    flex: 0 1 auto;
    display: flex;
    margin: 24px 16px 8px;
    overflow: hidden;
`;

export const LineItemsWrap = styled.div`
    display: flex;
    flex-direction: column;
    padding: 24px 16px 0;
    overflow-y: auto;

    ${({ theme }) => theme.superQuery.all.and.minWidth.desktopMin.css`
        max-height: 100%;

        > *:last-child {
            margin-bottom: 40px;
        }
    `};

    &::-webkit-scrollbar {
        display: none;
        width: 0 !important;
    }
    scrollbar-width: none;
`;

export const Empty = styled(EmptyCart)`
    position: absolute;
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    ${({ shouldShow }) =>
        shouldShow &&
        css`
            transition-property: visibility, opacity;
            transition-duration: ${ANIMATION_DURATION_IN_MS}ms;
            transition-delay: ${ANIMATION_DURATION_IN_MS / 2}ms;
            transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
            visibility: visible;
            opacity: 1;
        `};
`;

export const CloseButton = styled.button`
    border-radius: 50%;
    height: 48px;
    width: 48px;
    background-color: ${({ theme }) => theme.colors.Background};
    ${elevation(3)};
    margin-top: 30px;
    margin-right: 10px;
`;

export const CloseButtonRow = styled.div`
    display: flex;
    justify-content: flex-end;
    z-index: 1;
`;

export const Summary = styled(omitProps('visible')('div'))`
    z-index: 1;
    position: relative;
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    margin: auto 16px 0;
    padding: 8px 0;
    border-radius: 0;
    border-top: 2px solid ${({ theme }) => theme.colors['Level 1']};
    ${({ visible }) => !visible && 'visibility: hidden'};

    ${({ theme }) => theme.superQuery.all.and.minWidth.desktopMin.css`
        margin: 0 16px;
    `};
`;

export const SummaryWrap = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    margin-top: 8px;
`;

export const SummaryText = styled.p`
    ${({ theme }) => css(theme.typography.SmallHeadline)};
    color: ${({ theme }) => theme.colors.Foreground};

    span:last-child {
        ${({ theme }) => css(theme.typography.TinyParagraph)};
        line-height: 29px;
        margin-left: 8px;
    }
`;
